import React, { useEffect, useState, useCallback } from "react";
import { Calculator } from "../components/Calculator";
import { regimens as regimensMapper, suggestedDosages as suggestedDosagesMapper } from "../utils/csv/mappers";
import { saveRegimen } from "../utils/storage/regimens";
import { saveSuggestedDosage } from "../utils/storage/suggestedDosages";
import { SuggestedDosage, Regimen } from "../types/data";
import { loadAndSaveTable } from "../utils/csv";

export const Home: React.FC = () => {
  const [isFirstVisit, setIsFirstVisit] = useState(false);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisitedBefore");
    if (!hasVisited) {
      setIsFirstVisit(true);
      localStorage.setItem("hasVisitedBefore", "true");
    }
  }, []);

  const loadInitialData = useCallback(async () => {
    const tables = [
      {
        url: "https://raw.githubusercontent.com/peptidenow/sample-data/refs/heads/main/suggested_dosages.csv",
        mapper: suggestedDosagesMapper,
        saveFunction: saveSuggestedDosage,
      },
      {
        url: "https://raw.githubusercontent.com/peptidenow/sample-data/refs/heads/main/regimens.csv",
        mapper: regimensMapper,
        saveFunction: saveRegimen,
      },
    ];

    try {
      for (const { url, mapper, saveFunction } of tables) {
        await loadAndSaveTable(url, mapper, saveFunction);
      }
    } catch (error) {
      console.error("Failed to load initial data:", error);
    }
  }, []);

  useEffect(() => {
    if (isFirstVisit) {
      loadInitialData();
    }
  }, [isFirstVisit, loadInitialData]);

  return <Calculator />;
};
